module.exports = __webpack_public_path__ + "img/lg_ring_y_s_null_0@3x.6166dc3b.png";